import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { InfoMessageType } from "src/Components/InfoBar/InfoBar";
import { useEditPaymentMethod } from "src/Utils/Hooks/Payments/useEditPaymentMethod";

interface IEditPaymentMethod{
    clinicId: string;
    setInfo: (message: string, type: InfoMessageType) => void;
    updatePageLoader: (load: boolean) => void;
}

const EditPaymentMethod: React.FC<IEditPaymentMethod> = ({ clinicId, setInfo, updatePageLoader }) => {
    const { t } = useTranslation();
    const { getEditPaymentInfo, data, loading, error } = useEditPaymentMethod();

    useEffect(() => {
        if (error !== '') {
            setInfo(error, InfoMessageType.error);
        }
    }, [error, setInfo]);

    useEffect(() => {
        updatePageLoader(loading);
    }, [loading, updatePageLoader]);

    useEffect(() => {
        if (data?.paymentMethodUpdateUrl) {
            window.open(data?.paymentMethodUpdateUrl, '_self');
        }
    }, [data]);

    const handleClick = () => {
        getEditPaymentInfo(clinicId);
    };

    return(
        <div className="dropdown-item" id="edit-payment-method" onClick={handleClick}>
            {t('EditPaymentDetails')}
        </div>
    );
}

export default EditPaymentMethod;